<template>
  <div :class="inlineClasses">
    <label v-if="!labelRight" :for="id" class="form-label" :class="labelClass">{{ label }}</label>
    <input
        :id="id"
        :name="name"
        :class="inputClasses"
        type="radio"
        :disabled="disabled"
        :value="value"
        :checked="checked"
        @change="change"
    />
    <label v-if="labelRight" :for="id"  class="form-label" :class="labelClass">{{ label }}</label>
  </div>
</template>
<script>
export default {
  name: "my-radio",
  props: {
    error: {type: String},
    help: {type: String},
    id: {type: String},
    name: {type: String},
    label: {type: String},
    labelClass: {type: String},
    value: {type: String},
    disabled: {type: Boolean, default: false},
    labelRight: {type: Boolean, default: false},
    checked: {type: Boolean, default: false},
  },
  data() {
    return {
      myValue: this.value ? this.value : '',
    }
  },
  computed: {
    inlineClasses() {
      return 'flex mb-4 justify-start items-center';
    },
    inputClasses() {
      let classes = '';
      classes = this.labelRight ? ' mr-2' : ' ml-2';
      classes += this.error ? 'form-error' : '';
      return classes;
    }
  },
  methods: {
    change() {
      this.$emit('change', this.value);
    }
  }
}
</script>